import React, { useState } from "react";
import styles from "./Sidebar.module.sass";
import { Link, NavLink } from "react-router-dom";
import cn from "classnames";
import Icon from "../Icon";
import Theme from "../Theme";
import Dropdown from "./Dropdown";
import Help from "./Help";
import Image from "../Image";
import { useUser } from "../../context";
import LocaleDropDown from "../LocaleDropDown";
import sidebar from "../../i11/Sidebar";

const Sidebar = ({ className, onClose }) => {
	const [visibleHelp, setVisibleHelp] = useState(false);
	const [visible, setVisible] = useState(false);
	const {
		locale,
		tokens: { group },
		brand,
	} = useUser();

	return (
		<>
			<div
				className={cn(styles.sidebar, className, {
					[styles.active]: visible,
				})}
			>
				<button className={styles.close} onClick={onClose}>
					<Icon name="close" size="24" />
				</button>
				<div className={styles.bgforTop} />
				<Link className={styles.logo} to="/" onClick={onClose}>
					<Image
						className={styles.pic}
						src={
							brand?.image_list
								? brand?.image || "/images/logo-dark.png"
								: "/images/logo-dark.png"
						}
						srcDark={
							brand?.image_list
								? brand?.image || "/images/logo-light.png"
								: "/images/logo-light.png"
						}
						alt="Core"
					/>
				</Link>
				<div className={styles.menu}>
					{group === "admin"
						? brand && (
								<NavLink
									className={styles.item}
									activeClassName={styles.active}
									to="/explore-brands"
									exact
									onClick={onClose}
								>
									<Icon name="arrow-left" size="24" />
									{sidebar[locale].back}
								</NavLink>
						  )
						: ""}
					{sidebar[locale][
						group === "admin" && !brand ? "out" : group
					].map((x, index) => {
						if (!x.hide) {
							// if (x.url === "/raffle") return <div />;
							return x.url ? (
								x.isBlank ? (
									x.url === "dynamicLink" ? (
										<a
											rel="noreferrer"
											className={cn(styles.item, {
												[styles.color]: x.color,
											})}
											activeClassName={styles.active}
											href={brand?.domain}
											target="_blank"
											onClick={() => setVisible(false)}
											key={"eeell_" + index}
										>
											{x.icon && (
												<Icon name={x.icon} size="24" />
											)}
											{x.iconR && (
												<Icon
													reicon={x.iconR}
													size="24"
												/>
											)}
											{x.title}
										</a>
									) : (
										<a
											rel="noreferrer"
											className={cn(styles.item, {
												[styles.color]: x.color,
											})}
											activeClassName={styles.active}
											href={x.url}
											target="_blank"
											onClick={() => setVisible(false)}
											key={"eeell_" + index}
										>
											{x.icon && (
												<Icon name={x.icon} size="24" />
											)}
											{x.iconR && (
												<Icon
													reicon={x.iconR}
													size="24"
												/>
											)}
											{x.title}
										</a>
									)
								) : (
									<NavLink
										className={styles.item}
										activeClassName={styles.active}
										to={x.url}
										key={"temppp" + index}
										exact
										onClick={onClose}
									>
										{x.iconR && (
											<Icon reicon={x.iconR} size="24" />
										)}
										{x.icon && (
											<Icon name={x.icon} size="24" />
										)}

										{x.title}
									</NavLink>
								)
							) : (
								<Dropdown
									className={styles.dropdown}
									visibleSidebar={visible}
									setValue={setVisible}
									key={"elele" + index}
									item={x}
									onClose={onClose}
								/>
							);
						}
					})}
				</div>
				<button
					className={styles.toggle}
					onClick={() => setVisible(!visible)}
				>
					<Icon name="arrow-right" size="24" />
					<Icon name="close" size="24" />
				</button>
				<div className={styles.foot}>
					{/* <LocaleDropDown /> */}
					<Theme className={styles.theme} visibleSidebar={visible} />
				</div>
			</div>
			{/* <Help
				visible={visibleHelp}
				setVisible={setVisibleHelp}
				onClose={onClose}
			/> */}
			<div
				className={cn(styles.overlay, { [styles.active]: visible })}
				onClick={() => setVisible(false)}
			/>
		</>
	);
};

export default Sidebar;
